import { render, staticRenderFns } from "./TaskGrid.vue?vue&type=template&id=3f9cbb58&scoped=true&"
import script from "./TaskGrid.vue?vue&type=script&lang=js&"
export * from "./TaskGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9cbb58",
  null
  
)

export default component.exports